import React from 'react';
import { SC } from '../../styles/theme';
import { BRAND, isMarketGB } from '../../constants/main';
import { CheckoutPreOrderStyledAC } from './AC/CheckoutPreOrderStyled.AC';
import { CheckoutPreOrderStyledAP } from './AP/CheckoutPreOrderStyled.AP';
import { CheckoutPreOrderStyledDS } from './DS/CheckoutPreOrderStyled.DS';
import { CheckoutPreOrderStyledOV } from './OV/CheckoutPreOrderStyled.OV';
import { CheckoutPreOrderStyledOVGB } from './OV/GB/CheckoutPreOrderStyled.OV';
import { CheckoutPreOrderStyled } from './CheckoutPreOrderStyled';
import { Dispatch } from 'redux';

interface Props {
    handleRedirect: () => void;
    dispatch?: Dispatch;
    openValidationModal: boolean;
    showCatalanSwitch?: boolean;
    catalanFirstSelected?: boolean;
    catalanSecondSelected?: boolean;
    catalanThirdSelected?: boolean;
    handleToggleCatalanFirst?: () => void;
    handleToggleCatalanSecond?: () => void;
    handleToggleCatalanThird?: () => void;
}

export type CheckoutPreOrderProps = SC & Props;

const CheckoutPreOrder = (props: CheckoutPreOrderProps) => {
    if (BRAND === 'OV')
        return isMarketGB ? <CheckoutPreOrderStyledOVGB {...props} /> : <CheckoutPreOrderStyledOV {...props} />;
    if (BRAND === 'AC') return <CheckoutPreOrderStyledAC {...props} />;
    if (BRAND === 'AP') return <CheckoutPreOrderStyledAP {...props} />;
    if (BRAND === 'DS') return <CheckoutPreOrderStyledDS {...props} />;
    return <CheckoutPreOrderStyled {...props} />;
};

export default CheckoutPreOrder;
